export const baseApiUrl = process.env.REACT_APP_API_URL;

export const apiUrls = {
  loginUrl: baseApiUrl + "Login", // To login into the application provided email & password as query string params
  forgotPasswordUrl: baseApiUrl + "ForgotPassword", // To reset the password by providing emailID
  countryListUrl: baseApiUrl + "GetUserCountries?userid=", // To list the countries attached to each user ID
  customerTypes: baseApiUrl + "GetCustomerTypeRefs", // GET list of customer types | sold-to, ship-to
  customerGroupRefDataUrl:
    baseApiUrl + "Scenario/GetCustomerGroupReferenceData?", // GET customer levels and types
  relationshipLevelUrl: baseApiUrl + "Scenario/GetTrustLevel", // GET trust levels, all, high,...
  allEnumUrl: baseApiUrl + "Scenario/GetAllEnum", // GET breakdown, breakdonwtype and period type
  scenarioCriticalityList: baseApiUrl + "Scenario/GetScenarioCriticalityList",
  stickToQuota: baseApiUrl + "Scenario/GetSTQOPtions",
  searchScenario: baseApiUrl + "Scenario/GetScenario?",
  getScenarioDetails: baseApiUrl + "Scenario/GetScenarioDetails?",
  searchProductGroup: baseApiUrl + "Scenario/GetProductGroup?", // GET list of product groups
  searchCustomerGroup: baseApiUrl + "Scenario/GetCustomerandCustomerGroup", // GET customers and customer groups
  searchCGForCountry: baseApiUrl + "CustomerGroup/GetCstmrGrpforCntry?",
  searchCustToAdd: baseApiUrl + "CustomerGroup/GetCustomerSrch?",
  getCGDetail: baseApiUrl + "CustomerGroup/GetCstmrGrpDetail?",
  verifyScenario: baseApiUrl + "Scenario/VerifyScenario",
  submitScenario: baseApiUrl + "Scenario/SubmitScenario",
  saveScenario: baseApiUrl + "Scenario/SaveScenario",
  getDataSourcesByCountry: baseApiUrl + "Scenario/GetDatasourcesByCountry?", // GET list of data sources for a country
  localForecastDataAlignmentCheck:
    baseApiUrl + "Scenario/LocalForecastDataAlignmentCheck",
  MIDAS_DataAlignment: baseApiUrl + "Scenario/MidasAlignmentBasedOnFilter",
  ExportExcelPDF: baseApiUrl + "Scenario/ExportScenarioCustomerCreate?",
  DownLoadTemplate: baseApiUrl + "Scenario/DownloadTemplate",
  GetScenarioforQuotaDefinition:
    baseApiUrl + "Define/GetScenarioforQuotaDefinition?countryId=",
  GetQuotaPeriods: baseApiUrl + "Define/GetQuotaPeriods?scenarioId=",
  GetWeeklyDepletion: baseApiUrl + "Define/GetWeeklyDepletion",
  GetWeeklyDepletionValues: baseApiUrl + "Define/GetWeeklyDepletionValues",
  GetSKUOrPGByScenario: baseApiUrl + "Define/GetSKUOrPGByScenario?ScenarioID=",
  GetQuotaDetails: baseApiUrl + "Define/GetQuotaDetails?",
  GetQuotaChartData: baseApiUrl + "Define/GetQuotaChartData",
  SaveQuota: baseApiUrl + "Define/SaveQuota",
  SubmitQuota: baseApiUrl + "Define/SubmitQuota",
  ExportExcel: baseApiUrl + "Define/ExportExcel",
  ImportExcel: baseApiUrl + "Define/ImportExcel",
  GetDSAData: baseApiUrl + "Scenario/GetDataSourceAlignmentData?",
  SaveQuota: baseApiUrl + "Define/SaveQuota",
  SubmitQuota: baseApiUrl + "Define/SubmitQuota",
  ImportExcel: baseApiUrl + "Scenario/ImportExcel?",
  ImportExcelSKU: baseApiUrl + "Scenario/ImportExcelSKU?",
  MarketShareComparison: baseApiUrl + "Scenario/GetMarketShareComparison",
  SearchScenarioName: baseApiUrl + "Scenario/SearchScenarioName",
  MDR_DataAlignment : baseApiUrl + 'Scenario/MDRAlignmentBasedOnFilter',
  Local_DataAlignment : baseApiUrl + 'Scenario/LocalAlignmentBasedOnFilter',
};
